module.exports = __webpack_public_path__ + "portal/static/img/bangkok.681ae58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/bangkok.png
// module id = jWv/
// module chunks = 67